import React from 'react';
import { BiWorld, BiTimeFive } from 'react-icons/bi';
import './JobCard.css';

function JobCard(props) {
  const item = props.data;

  const date = item?.job_posted_at_datetime_utc
    ? item.job_posted_at_datetime_utc.split('T')
    : ['no date'];

  return (
    <div className="jobcard-container">

      <img
        src={
          item?.employer_logo
            ? item.employer_logo
            : "https://upload.wikimedia.org/wikipedia/commons/6/65/No-Image-Placeholder.svg"
        }
        className="jobcard-image"
        alt="Company Logo"
      />

      <div className="jobcard-content">

        <h3 className="jobcard-company">
          {item?.employer_name || "No company name available"}
        </h3>

        <h1 className="jobcard-title">
          {item?.job_title || "No job title available"}
        </h1>

        <div className="jobcard-details">

          <div className="jobcard-type">
            {item?.job_employment_type || "No employee type available"}
          </div>

          <div className="jobcard-meta">

            <div className="jobcard-meta-item">
              <BiWorld className="icon" />
              <span>
                {item?.job_country || "No country available"}
              </span>
            </div>

            <div className="jobcard-meta-item">
              <BiTimeFive className="icon" />
              <span>
                {date[0] || "No date available"}
              </span>
            </div>

          </div>

        </div>

      </div>

    </div>
  );
}

export default JobCard;